export const gbp = (pence) => `£${((pence || 0) / 100).toFixed(2).replace(/\.00$/, "")}`;

export const fmtDate = (iso, withTime = true) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-GB", {
    weekday: "short", day: "numeric", month: "short",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
    timeZone: "Europe/London",
  });
};

export const STATE_STYLE = {
  paid: { label: "Paid", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  pending: { label: "Awaiting payment", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  released: { label: "Released (unpaid)", cls: "bg-stone-100 text-stone-600 border-stone-200" },
  cancelled: { label: "Cancelled", cls: "bg-red-50 text-red-700 border-red-200" },
  refunded: { label: "Refunded", cls: "bg-red-50 text-red-700 border-red-200" },
};
